@if (
  (isCustomer | async) && ((dataLoading | async) || ((dataLoaded | async) && agents.length > 0))
) {
  <ds-overview-section
    class="overview-section--agents"
    [loading]="dataLoading | async"
    [spinnerText]="spinnerText"
    [sectionHeading]="sectionHeading"
    [newDesign]="true"
  >
    <ds-overview-section-content justifyCenter="true">
      @for (agent of agents; track agent) {
        <div class="agent-item-column">
          <agent-item
            [defaultContactNumber]="defaultContactNumber"
            [agent]="agent"
            [newTemplate]="true"
          ></agent-item>
        </div>
      }
    </ds-overview-section-content>
  </ds-overview-section>
}
